module.exports = __webpack_public_path__ + "img/analytics.f2445e88.png";